import { render, staticRenderFns } from "./selectKnowledge.vue?vue&type=template&id=b1400424&scoped=true&"
import script from "./selectKnowledge.vue?vue&type=script&lang=js&"
export * from "./selectKnowledge.vue?vue&type=script&lang=js&"
import style0 from "./selectKnowledge.vue?vue&type=style&index=0&id=b1400424&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1400424",
  null
  
)

export default component.exports